import { ChangeEventHandler } from 'react';
import Button from '@mui/material/Button';
import { FCX } from '@core/models';
import { useBulkImport } from '@core/api/usePublicItemsLockerFile';
import { toast } from "react-toastify";

const BulkImport: FCX = () => {
    const { doFetch } = useBulkImport();

    const handleFileChange: ChangeEventHandler<HTMLInputElement> = async (event) => {
        const fileList = event.target.files as FileList;
        if (!fileList) {
            return;
        }

        try {
            await doFetch({ data: { formFile: fileList?.[0] as unknown as string } }).then((res) => {
                if (res?.data?.length === 0) {
                    toast.success('Bulk import was successful');
                    return;
                }
                toast.error('Bulk import failed');
            });
        } catch (error) {
            toast.error('Bulk import failed');
        }
    };

    return (
        <div className="BulkImports">
            <Button component="label" role={undefined} tabIndex={-1} className="BulkImports__button">
                Bulk Import
                <input
                    className="PublicItemsLocker__hidden-input"
                    type="file"
                    accept="text/plain, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={handleFileChange}
                />
            </Button>
        </div>
    );
};

export default BulkImport;
